import React,{useEffect, useRef, useState} from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import About from "../Components/About";
import { factCards,logistics,services,clientLogos } from "../Data";
import aboutImg from '../Images/home-about.webp';
import Cta from "../Components/Cta";
import Whychoose from "../Components/WhyChoose";
import whyChooseImg from '../Images/home-why-choose.webp';
import manageBg from '../Images/home-manage.webp';
import IndustriesSlider from "../Components/IndustriesSlider";
import Cta2 from "../Components/Cta2";
import cta2Img from '../Images/cta-bg.webp';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";


const Home=()=>{
    useEffect(() => {
    document.title =
      "Transport & Logistics Solutions India | Shivam Transworld";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Pan-India transportation and logistics solutions offering full truck load, part load, and reliable delivery support for businesses across industries."
      );
    }

    const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Transport & Logistics Solutions India | Shivam Transworld"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Pan-India transportation and logistics solutions offering full truck load, part load, and reliable delivery support for businesses across industries."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Transport & Logistics Solutions India | Shivam Transworld"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Pan-India transportation and logistics solutions offering full truck load, part load, and reliable delivery support for businesses across industries."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);

const statsRef = useRef(null);
const [startAnim, setStartAnim] = useState(false);
const circumference = 282;


useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setStartAnim(true);
        observer.disconnect(); // run once
      }
    },
    { threshold: 0.35 }
  );

  if (statsRef.current) observer.observe(statsRef.current);

  return () => observer.disconnect();
}, []);



    return(
        <>

       <div className="spacing-div"></div>

       <section className="hero">
  <div className="hero-overlay">
    <motion.h1
      className="hero-title"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      Reliable Transport & Logistics Solutions
    </motion.h1>

    <motion.p
      className="hero-text"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.7, ease: "easeOut" }}
    >
      We provide full truck load, part load, and integrated logistics solutions
      to help businesses move goods safely and on time.
    </motion.p>
  </div>
</section>

       {/**image-content section */}
        <About 
        subheading="SHIVAM TRANSWORLD"
        heading="Your Trusted Partner for End-to-End Logistics"
        subtext="Shivam Transworld is your trusted partner for end-to-end logistics, delivering reliable, efficient, and customized transportation solutions across India. With over 11 years of industry experience, a strong network of 1000+ vehicles, and Pan-India coverage, we seamlessly manage full truck load, part load, and complete logistics requirements. From first-mile pickup to last-mile delivery, we ensure timely movement, cost efficiency, and complete visibility—helping businesses move faster, smarter, and with confidence."
        buttonText="Learn More About Us"
        buttonLink="/about-us"
        image={aboutImg}
        />

        {/**cards section */}
<section className="fact-cards">
  <motion.div
    className="cards-wrapper"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.18,
        },
      },
    }}
  >
    {factCards.map((item, index) => (
      <motion.div
        className="fact-card"
        key={index}
        variants={{
          hidden: {
            opacity: 0,
            y: 60,
            scale: 0.85,
          },
          visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
        whileHover={{
          y: -10,
          scale: 1.05,
        }}
        transition={{ type: "spring", stiffness: 250 }}
      >
        <div className="icon-box">
  {item.icon}
</div>

        <motion.h3
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35 }}
        >
          {item.title}
        </motion.h3>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45 }}
        >
          {item.desc}
        </motion.p>
      </motion.div>
    ))}
  </motion.div>
</section>


        {/**logistics stats section */}
  <section className="stats-section" ref={statsRef}>
   <motion.p
    className="section-label"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    STATISTICS
  </motion.p>

  {/* HEADING */}
  <motion.h2
    className="section-title"
    initial={{ opacity: 0, y: 35 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: true }}
  >
    Our Logistics Strength at a Glance
  </motion.h2>
  <div className="stats-grid">
    {logistics.map((item, i) => (
      <div className="stat-card" key={i}>
        <svg viewBox="0 0 200 100" className="semi-circle">
          <path
            d="M10,100 A90,90 0 0,1 190,100"
            className="bg"
          />
          <path
            d="M10,100 A90,90 0 0,1 190,100"
            className="progress"
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: startAnim
                ? circumference - (circumference * item.fill) / 100
                : circumference,
            }}
          />
        </svg>

        <h3>
          {startAnim && (
            <>
              <CountUp end={item.count} duration={2} />
              {item.suffix}
            </>
          )}
        </h3>

        <p>{item.label}</p>
      </div>
    ))}
  </div>
</section>

    {/**service cards section */}
   <section className="services-section">
  {/* SUBHEADING */}
  <motion.p
    className="section-label"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    SERVICES
  </motion.p>

  {/* HEADING */}
  <motion.h2
    className="section-title"
    initial={{ opacity: 0, y: 35 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: true }}
  >
    Our Transportation & Logistics Services
  </motion.h2>

  {/* SERVICES GRID */}
  <motion.div
    className="services-grid"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15,
          delayChildren: 0.2,
        },
      },
    }}
  >
    {services.slice(0, 6).map((service, i) => (
      <motion.div
        className="service-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 50,
            scale: 0.9,
          },
          visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
        whileHover={{
          y: -8,
          scale: 1.04,
        }}
        transition={{ type: "spring", stiffness: 220 }}
      >
          <Link to={`/services/${service.slug}`} className="service-card-link">
        <motion.div
        className="service-icon"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            delay: 0.2,
            type: "spring",
            stiffness: 300,
            
          }}
        >
          {service.icon}
        </motion.div>

        <h3>{service.title}</h3>
        <p>{service.introDesc}</p>
        </Link>
      </motion.div>
    ))}
  </motion.div>

  {/* BUTTON */}
  <motion.div
    className="services-btn-wrap"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.4, duration: 0.5 }}
    viewport={{ once: true }}
  >
    <motion.button
      className="primary-btn"
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <Link to='/services'>
      View All Services</Link>
    </motion.button>
  </motion.div>
</section>

      {/**cta section */}
      <Cta 
      bgImage={manageBg}/>

      {/**right transport option section */}
      <section className="transport-section">

  {/* SECTION HEADING */}
  <motion.h2
    className="section-title"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    viewport={{ once: true }}
  >
    Choosing the Right Transport Option
  </motion.h2>

  {/* GRID */}
  <motion.div
    className="transport-grid"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.18,
          delayChildren: 0.2,
        },
      },
    }}
  >
    {services.slice(0, 6).map((item, i) => (
      <motion.div
        className="transport-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 60,
            scale: 0.9,
          },
          visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
        whileHover={{
          y: -10,
          scale: 1.03,
        }}
        transition={{ type: "spring", stiffness: 220 }}
      >
        {/* ICON */}
        <motion.div
          className="icon-wrap"
          initial={{ scale: 0, rotate: -90 }}
          whileInView={{ scale: 1, rotate: 0 }}
          transition={{
            type: "spring",
            stiffness: 260,
            delay: 0.2,
          }}
          viewport={{ once: true }}
        >
          {item.icon}
        </motion.div>

        <h3>{item.title}</h3>

        <motion.p
          className="card-desc"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          viewport={{ once: true }}
        >
          {item.introDesc}
        </motion.p>

        <motion.ul
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.08,
                delayChildren: 0.25,
              },
            },
          }}
        >
          {item.points.map((pt, idx) => (
            <motion.li
              key={idx}
              variants={{
                hidden: { opacity: 0, x: -15 },
                visible: {
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.4 },
                },
              }}
            >
              {pt}
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>
    ))}
  </motion.div>

  {/* CTA BUTTON */}
  <motion.div
    className="center-btn"
    initial={{ opacity: 0, y: 25 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.4, duration: 0.6 }}
    viewport={{ once: true }}
  >
    <Link to='contact-us'>
    <motion.button
      className="primary-btn"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      Talk to our Team
    </motion.button>
    </Link>
  </motion.div>
</section>

      {/**industries slider */}
         <IndustriesSlider />

    {/**why choose us section */}
    <Whychoose
  heading="Why Businesses Choose Shivam Transworld"
  imageSrc={whyChooseImg}
  paragraph="Businesses choose Shivam Transworld for our reliability, experience, and ability to deliver customized logistics solutions across India. With 11+ years of industry expertise, a strong fleet network, and a customer-first approach, we ensure safe, timely, and cost-efficient transportation that keeps supply chains moving smoothly.
"
  listItems={[
    "Pan-India logistics coverage",
    "1000+ vehicle strong fleet network",
    "End-to-end transportation solutions",
    "Timely, secure, and reliable deliveries",
    "Trusted by leading industries and exporters"
  ]}
/>

    {/**client logo slider section */}
  <section className="clients-section">

      {/* HEADING */}
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        Trusted by Leading Companies
      </motion.h2>

      {/* SLIDER */}
      <div className="slider-wrapper">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={4}
          spaceBetween={0}
          loop
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={600}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {clientLogos.map((item, i) => (
            <SwiperSlide key={i}>
              <motion.div
                className="client-logo"
                initial={{ opacity: 0, y: 20, scale: 0.8 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{
                  duration: 0.5,
                  ease: "easeOut",
                  delay: i * 0.1,
                }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.08 }}
              >
                <img src={item.logo} alt={`client-logo-${i + 1}`} />
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

    </section>

<Cta2 
bgImage={cta2Img}/>

      </>
    )
}

export default Home;